<div class="buttons">
    <lucide-icon class="action" name="import" title="Import" (click)="showImport()" />
    <lucide-icon class="action" name="copy" title="Export to clipboard" (click)="saveToYaml()" />
    <lucide-icon class="action" name="refresh-ccw" title="Reset to empty config" (click)="reset()" />
    <lucide-icon class="action" name="notebook-pen" title="Reset to minimal config" (click)="setMinimum()" />
</div>

<app-dialog-popup #dialog>
  <div dialog-header>
    <span>clang-format's options</span>
  </div>
  <div dialog-body>
    Insert your <code>readability-identifier-naming.*</code> like:<br />
    <code class="code"><br />
CheckOptions:
  - key: readability-identifier-naming.TypedefCase
    value: 'aNy_CasE'<br />
    </code>
    <textarea #namingText rows="20"></textarea><br />
    <button type="button" (click)="importFromText()">Import</button>
  </div>
</app-dialog-popup>

<div class="case">
    <h2 class="title">
        Typedef
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="Typedef" name="Typedef" type="checkbox" [checked]="isChecked('Typedef')"
                    (change)="onCheckboxChange($event)" />
                <label for="Typedef">Typedef</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Typedef'), 'rule-checked': isChecked('Typedef') }">Typedef</span> / <span [ngClass]="{ 'valid': !isChecked('Typedef') }">unchanged</span></code><br />
            <code class="code">typedef int INTeGER;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Alias
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="TypeAlias" name="TypeAlias" type="checkbox" [checked]="isChecked('TypeAlias')"
                    (change)="onCheckboxChange($event)" />
                <label for="TypeAlias">TypeAlias</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('TypeAlias'), 'rule-checked': isChecked('TypeAlias') }">TypeAlias</span> / <span [ngClass]="{ 'valid': !isChecked('TypeAlias') }">unchanged</span></code><br />
            <code class="code">using DOUbLE = double;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Namespaces
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="InlineNamespace" name="InlineNamespace" type="checkbox"
                    [checked]="isChecked('InlineNamespace')" (change)="onCheckboxChange($event)" />
                <label for="InlineNamespace">InlineNamespace</label>
            </div>
            <div>
                <input id="Namespace" name="Namespace" type="checkbox" [checked]="isChecked('Namespace')"
                    (change)="onCheckboxChange($event)" />
                <label for="Namespace">Namespace</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('InlineNamespace'), 'rule-checked': isChecked('InlineNamespace') }">InlineNamespace</span> / <span [ngClass]="{ 'valid': !isChecked('InlineNamespace') && isChecked('Namespace'), 'rule-checked': isChecked('Namespace') }">Namespace</span> / <span [ngClass]="{ 'valid': !isChecked('InlineNamespace') && !isChecked('Namespace') }">unchanged</span></code><br />
            <code class="code">inline namespace NAMEsPACE &#123;&#125;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Namespace'), 'rule-checked': isChecked('Namespace') }">Namespace</span> / <span [ngClass]="{ 'valid': !isChecked('Namespace') }">unchanged</span></code><br />
            <code class="code">namespace NAMEsPACE &#123;&#125;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Enum
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="Enum" name="Enum" type="checkbox" [checked]="isChecked('Enum')"
                    (change)="onCheckboxChange($event)" />
                <label for="Enum">Enum</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Enum'), 'rule-checked': isChecked('Enum') }">Enum</span> / <span [ngClass]="{ 'valid': !isChecked('Enum') }">unchanged</span></code><br />
            <code class="code">enum eNUM &#123;&#125;
enum class eNuM &#123;&#125;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Constants in enum
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ScopedEnumConstant" name="ScopedEnumConstant" type="checkbox"
                    [checked]="isChecked('ScopedEnumConstant')" (change)="onCheckboxChange($event)" />
                <label for="ScopedEnumConstant">ScopedEnumConstant</label>
            </div>
            <div>
                <input id="EnumConstant" name="EnumConstant" type="checkbox" [checked]="isChecked('EnumConstant')"
                    (change)="onCheckboxChange($event)" />
                <label for="EnumConstant">EnumConstant</label>
            </div>
            <div>
                <input id="Constant_Enum" name="Constant_Enum" type="checkbox" [checked]="isChecked('Constant')"
                    (change)="onCheckboxChange($event)" />
                <label for="Constant_Enum">Constant</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">enum class eNUM &#123;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ScopedEnumConstant'), 'rule-checked': isChecked('ScopedEnumConstant') }">ScopedEnumConstant</span> / <span [ngClass]="{ 'valid': !isChecked('ScopedEnumConstant') && isChecked('EnumConstant'), 'rule-checked': isChecked('EnumConstant') }">EnumConstant</span> / <span [ngClass]="{ 'valid': !isChecked('ScopedEnumConstant') && !isChecked('EnumConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('ScopedEnumConstant') && !isChecked('EnumConstant') && !isChecked('Constant') }">unchanged</span><br /></code>
            <code class="code">  EnuM_CONST
&#125;;
enum eNUM &#123;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('EnumConstant'), 'rule-checked': isChecked('EnumConstant') }">EnumConstant</span> / <span [ngClass]="{ 'valid': !isChecked('EnumConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('EnumConstant') && !isChecked('Constant') }">unchanged</span><br /></code>
            <code class="code">  EnuM_CONST
&#125;;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        struct / class / union
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="AbstractClass" name="AbstractClass" type="checkbox" [checked]="isChecked('AbstractClass')"
                    (change)="onCheckboxChange($event)" />
                <label for="AbstractClass">AbstractClass</label>
            </div>
            <div>
                <input id="Struct" name="Struct" type="checkbox" [checked]="isChecked('Struct')"
                    (change)="onCheckboxChange($event)" />
                <label for="Struct">Struct</label>
            </div>
            <div>
                <input id="Class" name="Class" type="checkbox" [checked]="isChecked('Class')"
                    (change)="onCheckboxChange($event)" />
                <label for="Class">Class</label>
            </div>
            <div>
                <input id="Union" name="Union" type="checkbox" [checked]="isChecked('Union')"
                    (change)="onCheckboxChange($event)" />
                <label for="Union">Union</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('AbstractClass'), 'rule-checked': isChecked('AbstractClass') }">AbstractClass</span> / <span [ngClass]="{ 'valid': !isChecked('AbstractClass') && isChecked('Class'), 'rule-checked': isChecked('Class') }">Class</span> / <span [ngClass]="{ 'valid': !isChecked('AbstractClass') && !isChecked('Class') && isChecked('Struct'), 'rule-checked': isChecked('Struct') }">Struct</span> / <span [ngClass]="{ 'valid': !isChecked('AbstractClass') && !isChecked('Class') && !isChecked('Struct') }">unchanged</span><br /></code>
            <code class="code">class ABStract &#123;
  virtual fOo() = 0;
&#125;;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Class'), 'rule-checked': isChecked('Class') }">Class</span> / <span [ngClass]="{ 'valid': !isChecked('Class') && isChecked('Struct'), 'rule-checked': isChecked('Struct') }">Struct</span> / <span [ngClass]="{ 'valid': !isChecked('Class') && !isChecked('Struct') }">unchanged</span><br /></code>
            <code class="code">class ClAsS &#123;&#125;;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Struct'), 'rule-checked': isChecked('Struct') }">Struct</span> / <span [ngClass]="{ 'valid': !isChecked('Struct') && isChecked('Class'), 'rule-checked': isChecked('Class') }">Class</span> / <span [ngClass]="{ 'valid': !isChecked('Struct') && !isChecked('Class') }">unchanged</span><br /></code>
            <code class="code">struct STRuct &#123;&#125;;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Union'), 'rule-checked': isChecked('Union') }">Union</span> / <span [ngClass]="{ 'valid': !isChecked('Union') }">unchanged</span><br /></code>
            <code class="code">union UnIon &#123;&#125;;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Members
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstantMember" name="ConstantMember" type="checkbox" [checked]="isChecked('ConstantMember')"
                    (change)="onCheckboxChange($event)" />
                <label for="ConstantMember">ConstantMember</label>
            </div>
            <div>
                <input id="Constant_Member" name="Constant_Member" type="checkbox" [checked]="isChecked('Constant')"
                    (change)="onCheckboxChange($event)" />
                <label for="Constant_Member">Constant</label>
            </div>
            <div>
                <input id="PrivateMember" name="PrivateMember" type="checkbox" [checked]="isChecked('PrivateMember')"
                    (change)="onCheckboxChange($event)" />
                <label for="PrivateMember">PrivateMember</label>
            </div>
            <div>
                <input id="ProtectedMember" name="ProtectedMember" type="checkbox"
                    [checked]="isChecked('ProtectedMember')" (change)="onCheckboxChange($event)" />
                <label for="ProtectedMember">ProtectedMember</label>
            </div>
            <div>
                <input id="PublicMember" name="PublicMember" type="checkbox" [checked]="isChecked('PublicMember')"
                    (change)="onCheckboxChange($event)" />
                <label for="PublicMember">PublicMember</label>
            </div>
            <div>
                <input id="Member" name="Member" type="checkbox" [checked]="isChecked('Member')"
                    (change)="onCheckboxChange($event)" />
                <label for="Member">Member</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">class ClAss &#123;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ConstantMember'), 'rule-checked': isChecked('ConstantMember') }">ConstantMember</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantMember') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantMember') && !isChecked('Constant') && isChecked('PrivateMember'), 'rule-checked': isChecked('PrivateMember') }">PrivateMember</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantMember') && !isChecked('Constant') && !isChecked('PrivateMember') && isChecked('Member'), 'rule-checked': isChecked('Member') }">Member</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantMember') && !isChecked('Constant') && !isChecked('PrivateMember') && !isChecked('Member')}">unchanged</span><br /></code>
            <code class="code">  const int InT;
 private:<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('PrivateMember'), 'rule-checked': isChecked('PrivateMember') }">PrivateMember</span> / <span [ngClass]="{ 'valid': !isChecked('PrivateMember') && isChecked('Member'), 'rule-checked': isChecked('Member') }">Member</span> / <span [ngClass]="{ 'valid': !isChecked('PrivateMember') && !isChecked('Member')}">unchanged</span><br /></code>
            <code class="code">  short ShorT;
 protected:<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ProtectedMember'), 'rule-checked': isChecked('ProtectedMember') }">ProtectedMember</span> / <span [ngClass]="{ 'valid': !isChecked('ProtectedMember') && isChecked('Member'), 'rule-checked': isChecked('Member') }">Member</span> / <span [ngClass]="{ 'valid': !isChecked('ProtectedMember') && !isChecked('Member')}">unchanged</span><br /></code>
            <code class="code">  double DoublE;
 public:<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('PublicMember'), 'rule-checked': isChecked('PublicMember') }">PublicMember</span> / <span [ngClass]="{ 'valid': !isChecked('PublicMember') && isChecked('Member'), 'rule-checked': isChecked('Member') }">Member</span> / <span [ngClass]="{ 'valid': !isChecked('PublicMember') && !isChecked('Member')}">unchanged</span><br /></code>
            <code class="code">  float FloaT;
&#125;;<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Parameters
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstantPointerParameter" name="ConstantPointerParameter" type="checkbox"
                    [checked]="isChecked('ConstantPointerParameter')" (change)="onCheckboxChange($event)" />
                <label for="ConstantPointerParameter">ConstantPointerParameter</label>
            </div>
            <div>
                <input id="ConstantParameter" name="ConstantParameter" type="checkbox"
                    [checked]="isChecked('ConstantParameter')" (change)="onCheckboxChange($event)" />
                <label for="ConstantParameter">ConstantParameter</label>
            </div>
            <div>
                <input id="Constant_Parameter" name="Constant_Parameter" type="checkbox"
                    [checked]="isChecked('Constant')" (change)="onCheckboxChange($event)" />
                <label for="Constant_Parameter">Constant</label>
            </div>
            <div>
                <input id="ParameterPack" name="ParameterPack" type="checkbox" [checked]="isChecked('ParameterPack')"
                    (change)="onCheckboxChange($event)" />
                <label for="ParameterPack">ParameterPack</label>
            </div>
            <div>
                <input id="PointerParameter" name="PointerParameter" type="checkbox"
                    [checked]="isChecked('PointerParameter')" (change)="onCheckboxChange($event)" />
                <label for="PointerParameter">PointerParameter</label>
            </div>
            <div>
                <input id="Parameter" name="Parameter" type="checkbox" [checked]="isChecked('Parameter')"
                    (change)="onCheckboxChange($event)" />
                <label for="Parameter">Parameter</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">template &lt;class... Types&gt;
void fOo(<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ConstantPointerParameter'), 'rule-checked': isChecked('ConstantPointerParameter') }">ConstantPointerParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantPointerParameter') && isChecked('ConstantParameter'), 'rule-checked': isChecked('ConstantParameter') }">ConstantParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantPointerParameter') && !isChecked('ConstantParameter') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantPointerParameter') && !isChecked('ConstantParameter') && !isChecked('Constant') && isChecked('PointerParameter'), 'rule-checked': isChecked('PointerParameter') }">PointerParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantPointerParameter') && !isChecked('ConstantParameter') && !isChecked('Constant') && !isChecked('PointerParameter') && isChecked('Parameter'), 'rule-checked': isChecked('Parameter') }">Parameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantPointerParameter') && !isChecked('ConstantParameter') && !isChecked('Constant') && !isChecked('PointerParameter') && !isChecked('Parameter') }">unchanged</span><br /></code>
            <code class="code">  const int *IiI,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ConstantParameter'), 'rule-checked': isChecked('ConstantParameter') }">ConstantParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantParameter') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantParameter') && !isChecked('Constant') && isChecked('Parameter'), 'rule-checked': isChecked('Parameter') }">Parameter</span> / <span [ngClass]="{ 'valid': !isChecked('ConstantParameter') && !isChecked('Constant') && !isChecked('Parameter') }">unchanged</span><br /></code>
            <code class="code">  const short &ShorT,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('PointerParameter'), 'rule-checked': isChecked('PointerParameter') }">PointerParameter</span> / <span [ngClass]="{ 'valid': !isChecked('PointerParameter') && isChecked('Parameter'), 'rule-checked': isChecked('Parameter') }">Parameter</span> / <span [ngClass]="{ 'valid': !isChecked('PointerParameter') && !isChecked('Parameter') }">unchanged</span><br /></code>
            <code class="code">  int *JjJ,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('Parameter'), 'rule-checked': isChecked('Parameter') }">Parameter</span> / <span [ngClass]="{ 'valid': !isChecked('Parameter') }">unchanged</span><br /></code>
            <code class="code">  short SsS,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ParameterPack'), 'rule-checked': isChecked('ParameterPack') }">ParameterPack</span> / <span [ngClass]="{ 'valid': !isChecked('ParameterPack') && isChecked('Parameter'), 'rule-checked': isChecked('Parameter') }">Parameter</span> / <span [ngClass]="{ 'valid': !isChecked('ParameterPack') && !isChecked('Parameter') }">unchanged</span><br /></code>
            <code class="code">  Types... arGs);</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Local variables
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstexprVariable_Local" name="ConstexprVariable_Local" type="checkbox"
                    [checked]="isChecked('ConstexprVariable')" (change)="onCheckboxChange($event)" />
                <label for="ConstexprVariable_Local">ConstexprVariable</label>
            </div>
            <div>
                <input id="StaticConstant" name="StaticConstant" type="checkbox" [checked]="isChecked('StaticConstant')"
                    (change)="onCheckboxChange($event)" />
                <label for="StaticConstant">StaticConstant</label>
            </div>
            <div>
                <input id="LocalConstantPointer" name="LocalConstantPointer" type="checkbox"
                    [checked]="isChecked('LocalConstantPointer')" (change)="onCheckboxChange($event)" />
                <label for="LocalConstantPointer">LocalConstantPointer</label>
            </div>
            <div>
                <input id="LocalConstant" name="LocalConstant" type="checkbox" [checked]="isChecked('LocalConstant')"
                    (change)="onCheckboxChange($event)" />
                <label for="LocalConstant">LocalConstant</label>
            </div>
            <div>
                <input id="Constant_Local" name="Constant_Local" type="checkbox" [checked]="isChecked('Constant')"
                    (change)="onCheckboxChange($event)" />
                <label for="Constant_Local">Constant</label>
            </div>
            <div>
                <input id="StaticVariable" name="StaticVariable" type="checkbox" [checked]="isChecked('StaticVariable')"
                    (change)="onCheckboxChange($event)" />
                <label for="StaticVariable">StaticVariable</label>
            </div>
            <div>
                <input id="LocalPointer" name="LocalPointer" type="checkbox" [checked]="isChecked('LocalPointer')"
                    (change)="onCheckboxChange($event)" />
                <label for="LocalPointer">LocalPointer</label>
            </div>
            <div>
                <input id="LocalVariable" name="LocalVariable" type="checkbox" [checked]="isChecked('LocalVariable')"
                    (change)="onCheckboxChange($event)" />
                <label for="LocalVariable">LocalVariable</label>
            </div>
            <div>
                <input id="Variable_Local" name="Variable_Local" type="checkbox" [checked]="isChecked('Variable')"
                    (change)="onCheckboxChange($event)" />
                <label for="Variable_Local">Variable</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">&#123;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ConstexprVariable'), 'rule-checked': isChecked('ConstexprVariable') }">ConstexprVariable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  constexpr int eE = 150;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('StaticConstant'), 'rule-checked': isChecked('StaticConstant') }">StaticConstant</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && isChecked('LocalConstant'), 'rule-checked': isChecked('LocalConstant') }">LocalConstant</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && !isChecked('LocalConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && !isChecked('LocalConstant') && !isChecked('Constant') && isChecked('StaticVariable'), 'rule-checked': isChecked('StaticVariable') }">StaticVariable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('StaticVariable') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('StaticVariable') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticConstant') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('StaticVariable') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  static const int Ee = 150;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('LocalConstantPointer'), 'rule-checked': isChecked('LocalConstantPointer') }">LocalConstantPointer</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && isChecked('LocalConstant'), 'rule-checked': isChecked('LocalConstant') }">LocalConstant</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && !isChecked('LocalConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && !isChecked('LocalConstant') && !isChecked('Constant') && isChecked('LocalPointer'), 'rule-checked': isChecked('LocalPointer') }">LocalPointer</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('LocalPointer') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('LocalPointer') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstantPointer') && !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('LocalPointer') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  const int *Jj = nullptr;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('LocalConstant'), 'rule-checked': isChecked('LocalConstant') }">LocalConstant</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstant') && !isChecked('Constant') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalConstant') && !isChecked('Constant') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  const int Jj = 150;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('StaticVariable'), 'rule-checked': isChecked('StaticVariable') }">StaticVariable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticVariable') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticVariable') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('StaticVariable') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  static int Ee = 150;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('LocalPointer'), 'rule-checked': isChecked('LocalPointer') }">LocalPointer</span> / <span [ngClass]="{ 'valid': !isChecked('LocalPointer') && isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalPointer') && !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalPointer') && !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  int *Jj = nullptr;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('LocalVariable'), 'rule-checked': isChecked('LocalVariable') }">LocalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('LocalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  int Jj = 150;
&#125;<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Global variables
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstexprVariable_Global" name="ConstexprVariable_Global" type="checkbox"
                    [checked]="isChecked('ConstexprVariable')" (change)="onCheckboxChange($event)" />
                <label for="ConstexprVariable_Global">ConstexprVariable</label>
            </div>
            <div>
                <input id="GlobalConstantPointer" name="GlobalConstantPointer" type="checkbox"
                    [checked]="isChecked('GlobalConstantPointer')" (change)="onCheckboxChange($event)" />
                <label for="GlobalConstantPointer">GlobalConstantPointer</label>
            </div>
            <div>
                <input id="GlobalConstant" name="GlobalConstant" type="checkbox" [checked]="isChecked('GlobalConstant')"
                    (change)="onCheckboxChange($event)" />
                <label for="GlobalConstant">GlobalConstant</label>
            </div>
            <div>
                <input id="Constant_Global" name="Constant_Global" type="checkbox" [checked]="isChecked('Constant')"
                    (change)="onCheckboxChange($event)" />
                <label for="Constant_Global">Constant</label>
            </div>
            <div>
                <input id="GlobalPointer" name="GlobalPointer" type="checkbox" [checked]="isChecked('GlobalPointer')"
                    (change)="onCheckboxChange($event)" />
                <label for="GlobalPointer">GlobalPointer</label>
            </div>
            <div>
                <input id="GlobalVariable" name="GlobalVariable" type="checkbox" [checked]="isChecked('GlobalVariable')"
                    (change)="onCheckboxChange($event)" />
                <label for="GlobalVariable">GlobalVariable</label>
            </div>
            <div>
                <input id="Variable_Global" name="Variable_Global" type="checkbox" [checked]="isChecked('Variable')"
                    (change)="onCheckboxChange($event)" />
                <label for="Variable_Global">Variable</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('ConstexprVariable'), 'rule-checked': isChecked('ConstexprVariable') }">ConstexprVariable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && isChecked('GlobalVariable'), 'rule-checked': isChecked('GlobalVariable') }">GlobalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && !isChecked('GlobalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprVariable') && !isChecked('GlobalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">constexpr int eE = 150;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('GlobalConstantPointer'), 'rule-checked': isChecked('GlobalConstantPointer') }">GlobalConstantPointer</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && isChecked('GlobalConstant'), 'rule-checked': isChecked('GlobalConstant') }">GlobalConstant</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && !isChecked('GlobalConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && !isChecked('GlobalConstant') && !isChecked('Constant') && isChecked('GlobalPointer'), 'rule-checked': isChecked('GlobalPointer') }">GlobalPointer</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && !isChecked('GlobalConstant') && !isChecked('Constant') && !isChecked('GlobalPointer') && isChecked('GlobalVariable'), 'rule-checked': isChecked('GlobalVariable') }">GlobalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && !isChecked('GlobalConstant') && !isChecked('Constant') && !isChecked('GlobalPointer') && !isChecked('GlobalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstantPointer') && !isChecked('GlobalConstant') && !isChecked('Constant') && !isChecked('GlobalPointer') && !isChecked('GlobalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">const int *Jj = nullptr;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('GlobalConstant'), 'rule-checked': isChecked('GlobalConstant') }">GlobalConstant</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstant') && !isChecked('Constant') && isChecked('GlobalVariable'), 'rule-checked': isChecked('GlobalVariable') }">GlobalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstant') && !isChecked('Constant') && !isChecked('GlobalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalConstant') && !isChecked('Constant') && !isChecked('GlobalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">const int Jj = 150;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('GlobalPointer'), 'rule-checked': isChecked('GlobalPointer') }">GlobalPointer</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalPointer') && isChecked('GlobalVariable'), 'rule-checked': isChecked('GlobalVariable') }">GlobalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalPointer') && !isChecked('GlobalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalPointer') && !isChecked('GlobalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">int *Jj = nullptr;<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('GlobalVariable'), 'rule-checked': isChecked('GlobalVariable') }">GlobalVariable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalVariable') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalVariable') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">int Jj = 150;<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Static member variables
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ClassConstant" name="ClassConstant" type="checkbox" [checked]="isChecked('ClassConstant')"
                    (change)="onCheckboxChange($event)" />
                <label for="ClassConstant">ClassConstant</label>
            </div>
            <div>
                <input id="Constant_StaticMember" name="Constant_StaticMember" type="checkbox"
                    [checked]="isChecked('Constant')" (change)="onCheckboxChange($event)" />
                <label for="Constant_StaticMember">Constant</label>
            </div>
            <div>
                <input id="ClassMember" name="ClassMember" type="checkbox" [checked]="isChecked('ClassMember')"
                    (change)="onCheckboxChange($event)" />
                <label for="ClassMember">ClassMember</label>
            </div>
            <div>
                <input id="Variable_Member" name="Variable_Member" type="checkbox" [checked]="isChecked('Variable')"
                    (change)="onCheckboxChange($event)" />
                <label for="Variable_Member">Variable</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">class ClAss &#123;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ClassConstant'), 'rule-checked': isChecked('ClassConstant') }">ClassConstant</span> / <span [ngClass]="{ 'valid': !isChecked('ClassConstant') && isChecked('Constant'), 'rule-checked': isChecked('Constant') }">Constant</span> / <span [ngClass]="{ 'valid': !isChecked('ClassConstant') && !isChecked('Constant') && isChecked('ClassMember'), 'rule-checked': isChecked('ClassMember') }">ClassMember</span> / <span [ngClass]="{ 'valid': !isChecked('ClassConstant') && !isChecked('Constant') && !isChecked('ClassMember') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('ClassConstant') && !isChecked('Constant') && !isChecked('ClassMember') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  static const int eE = 150;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ClassMember'), 'rule-checked': isChecked('ClassMember') }">ClassMember</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMember') && isChecked('Variable'), 'rule-checked': isChecked('Variable') }">Variable</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMember') && !isChecked('Variable') }">unchanged</span><br /></code>
            <code class="code">  static int Ee = 150;
&#125;<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Methods
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstexprMethod" name="ConstexprMethod" type="checkbox"
                    [checked]="isChecked('ConstexprMethod')" (change)="onCheckboxChange($event)" />
                <label for="ConstexprMethod">ConstexprMethod</label>
            </div>
            <div>
                <input id="ConstexprFunction" name="ConstexprFunction" type="checkbox"
                    [checked]="isChecked('ConstexprFunction')" (change)="onCheckboxChange($event)" />
                <label for="ConstexprFunction">ConstexprFunction</label>
            </div>
            <div>
                <input id="ClassMethod" name="ClassMethod" type="checkbox" [checked]="isChecked('ClassMethod')"
                    (change)="onCheckboxChange($event)" />
                <label for="ClassMethod">ClassMethod</label>
            </div>
            <div>
                <input id="VirtualMethod" name="VirtualMethod" type="checkbox" [checked]="isChecked('VirtualMethod')"
                    (change)="onCheckboxChange($event)" />
                <label for="VirtualMethod">VirtualMethod</label>
            </div>
            <div>
                <input id="PrivateMethod" name="PrivateMethod" type="checkbox" [checked]="isChecked('PrivateMethod')"
                    (change)="onCheckboxChange($event)" />
                <label for="PrivateMethod">PrivateMethod</label>
            </div>
            <div>
                <input id="ProtectedMethod" name="ProtectedMethod" type="checkbox"
                    [checked]="isChecked('ProtectedMethod')" (change)="onCheckboxChange($event)" />
                <label for="ProtectedMethod">ProtectedMethod</label>
            </div>
            <div>
                <input id="PublicMethod" name="PublicMethod" type="checkbox" [checked]="isChecked('PublicMethod')"
                    (change)="onCheckboxChange($event)" />
                <label for="PublicMethod">PublicMethod</label>
            </div>
            <div>
                <input id="Method" name="Method" type="checkbox" [checked]="isChecked('Method')"
                    (change)="onCheckboxChange($event)" />
                <label for="Method">Method</label>
            </div>
            <div>
                <input id="Function" name="Function" type="checkbox" [checked]="isChecked('Function')"
                    (change)="onCheckboxChange($event)" />
                <label for="Function">Function</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">class A &#123;
 public:
  virtual void fOo()= 0;
&#125;
class B : public A &#123;
 public:<br /></code>
            <code class="comment">  // Override is skipped.<br /></code>
            <code class="code">  void fOo() override;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ConstexprMethod'), 'rule-checked': isChecked('ConstexprMethod') }">ConstexprMethod</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprMethod') && isChecked('ConstexprFunction'), 'rule-checked': isChecked('ConstexprFunction') }">ConstexprFunction</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprMethod') && !isChecked('ConstexprFunction') && isChecked('PublicMethod'), 'rule-checked': isChecked('PublicMethod') }">PublicMethod</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprMethod') && !isChecked('ConstexprFunction') && !isChecked('PublicMethod') && isChecked('Method'), 'rule-checked': isChecked('Method') }">Method</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprMethod') && !isChecked('ConstexprFunction') && !isChecked('PublicMethod') && !isChecked('Method') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprMethod') && !isChecked('ConstexprFunction') && !isChecked('PublicMethod') && !isChecked('Method') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">  constexpr int fOo2();<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ClassMethod'), 'rule-checked': isChecked('ClassMethod') }">ClassMethod</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMethod') && isChecked('PublicMethod'), 'rule-checked': isChecked('PublicMethod') }">PublicMethod</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMethod') && !isChecked('PublicMethod') && isChecked('Method'), 'rule-checked': isChecked('Method') }">Method</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMethod') && !isChecked('PublicMethod') && !isChecked('Method') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('ClassMethod') && !isChecked('PublicMethod') && !isChecked('Method') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">  static void fOo3();<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('VirtualMethod'), 'rule-checked': isChecked('VirtualMethod') }">VirtualMethod</span> / <span [ngClass]="{ 'valid': !isChecked('VirtualMethod') && isChecked('PublicMethod'), 'rule-checked': isChecked('PublicMethod') }">PublicMethod</span> / <span [ngClass]="{ 'valid': !isChecked('VirtualMethod') && !isChecked('PublicMethod') && isChecked('Method'), 'rule-checked': isChecked('Method') }">Method</span> / <span [ngClass]="{ 'valid': !isChecked('VirtualMethod') && !isChecked('PublicMethod') && !isChecked('Method') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('VirtualMethod') && !isChecked('PublicMethod') && !isChecked('Method') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">  virtual void fOo4();
 private:<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('PrivateMethod'), 'rule-checked': isChecked('PrivateMethod') }">PrivateMethod</span> / <span [ngClass]="{ 'valid': !isChecked('PrivateMethod') && isChecked('Method'), 'rule-checked': isChecked('Method') }">Method</span> / <span [ngClass]="{ 'valid': !isChecked('PrivateMethod') && !isChecked('Method') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('PrivateMethod') && !isChecked('Method') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">  void fOo5();
 protected:<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ProtectedMethod'), 'rule-checked': isChecked('ProtectedMethod') }">ProtectedMethod</span> / <span [ngClass]="{ 'valid': !isChecked('ProtectedMethod') && isChecked('Method'), 'rule-checked': isChecked('Method') }">Method</span> / <span [ngClass]="{ 'valid': !isChecked('ProtectedMethod') && !isChecked('Method') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('ProtectedMethod') && !isChecked('Method') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">  void fOo6();
&#125;</code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Functions
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="ConstexprFunction" name="ConstexprFunction" type="checkbox"
                    [checked]="isChecked('ConstexprFunction')" (change)="onCheckboxChange($event)" />
                <label for="ConstexprFunction">ConstexprFunction</label>
            </div>
            <div>
                <input id="GlobalFunction" name="GlobalFunction" type="checkbox" [checked]="isChecked('GlobalFunction')"
                    (change)="onCheckboxChange($event)" />
                <label for="GlobalFunction">GlobalFunction</label>
            </div>
            <div>
                <input id="Function" name="Function" type="checkbox" [checked]="isChecked('Function')"
                    (change)="onCheckboxChange($event)" />
                <label for="Function">Function</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('ConstexprFunction'), 'rule-checked': isChecked('ConstexprFunction') }">ConstexprFunction</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprFunction') && isChecked('GlobalFunction'), 'rule-checked': isChecked('GlobalFunction') }">GlobalFunction</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprFunction') && !isChecked('GlobalFunction') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('ConstexprFunction') && !isChecked('GlobalFunction') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">constexpr void b1r();<br /></code>
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('GlobalFunction'), 'rule-checked': isChecked('GlobalFunction') }">GlobalFunction</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalFunction') && isChecked('Function'), 'rule-checked': isChecked('Function') }">Function</span> / <span [ngClass]="{ 'valid': !isChecked('GlobalFunction') && !isChecked('Function') }">unchanged</span><br /></code>
            <code class="code">void bAr()<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Templates
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="TypeTemplateParameter" name="TypeTemplateParameter" type="checkbox"
                    [checked]="isChecked('TypeTemplateParameter')" (change)="onCheckboxChange($event)" />
                <label for="TypeTemplateParameter">TypeTemplateParameter</label>
            </div>
            <div>
                <input id="ValueTemplateParameter" name="ValueTemplateParameter" type="checkbox"
                    [checked]="isChecked('ValueTemplateParameter')" (change)="onCheckboxChange($event)" />
                <label for="ValueTemplateParameter">ValueTemplateParameter</label>
            </div>
            <div>
                <input id="TemplateTemplateParameter" name="TemplateTemplateParameter" type="checkbox"
                    [checked]="isChecked('TemplateTemplateParameter')" (change)="onCheckboxChange($event)" />
                <label for="TemplateTemplateParameter">TemplateTemplateParameter</label>
            </div>
            <div>
                <input id="TemplateParameter" name="TemplateParameter" type="checkbox"
                    [checked]="isChecked('TemplateParameter')" (change)="onCheckboxChange($event)" />
                <label for="TemplateParameter">TemplateParameter</label>
            </div>
        </div>
        <div class="examples">
            <code class="code">template&lt;<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('TypeTemplateParameter'), 'rule-checked': isChecked('TypeTemplateParameter') }">TypeTemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('TypeTemplateParameter') && isChecked('TemplateParameter'), 'rule-checked': isChecked('TemplateParameter') }">TemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('TypeTemplateParameter') && !isChecked('TemplateParameter') }">unchanged</span><br /></code>
            <code class="code">  typename TypeName,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('ValueTemplateParameter'), 'rule-checked': isChecked('ValueTemplateParameter') }">ValueTemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ValueTemplateParameter') && isChecked('TemplateParameter'), 'rule-checked': isChecked('TemplateParameter') }">TemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('ValueTemplateParameter') && !isChecked('TemplateParameter') }">unchanged</span><br /></code>
            <code class="code">  int VaLuE,<br /></code>
            <code
                class="comment">  // Naming: <span [ngClass]="{ 'valid': isChecked('TemplateTemplateParameter'), 'rule-checked': isChecked('TemplateTemplateParameter') }">TemplateTemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('TemplateTemplateParameter') && isChecked('TemplateParameter'), 'rule-checked': isChecked('TemplateParameter') }">TemplateParameter</span> / <span [ngClass]="{ 'valid': !isChecked('TemplateTemplateParameter') && !isChecked('TemplateParameter') }">unchanged</span><br /></code>
            <code class="code">  template&lt;typename&gt; typename TypeTypeName
&gt; void FoBa();<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Concept
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="Concept" name="Concept" type="checkbox" [checked]="isChecked('Concept')"
                    (change)="onCheckboxChange($event)" />
                <label for="Concept">Concept</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('Concept'), 'rule-checked': isChecked('Concept') }">Concept</span> / <span [ngClass]="{ 'valid': !isChecked('Concept') }">unchanged</span><br /></code>
            <code class="code">template&lt;class T, class U&gt;
concept ConCepT = std::is_base_of&lt;U, T&gt;::value;<br /></code>
        </div>
    </div>
</div>

<div class="case">
    <h2 class="title">
        Macro
    </h2>
    <div class="content">
        <div class="checkboxes">
            <div>
                <input id="MacroDefinition" name="MacroDefinition" type="checkbox"
                    [checked]="isChecked('MacroDefinition')" (change)="onCheckboxChange($event)" />
                <label for="MacroDefinition">MacroDefinition</label>
            </div>
        </div>
        <div class="examples">
            <code
                class="comment">// Naming: <span [ngClass]="{ 'valid': isChecked('MacroDefinition'), 'rule-checked': isChecked('MacroDefinition') }">MacroDefinition</span> / <span [ngClass]="{ 'valid': !isChecked('MacroDefinition') }">unchanged</span><br /></code>
            <code class="code">#define MaCrO<br /></code>
        </div>
    </div>
</div>

<a href="https://github.com/bansan85/web-demangler">
    <app-github-mark-inline class="github_logo" />
</a>